'use client'
import { envs } from '@config/envs'
import { useEffect, useState } from 'react'

export function useLatencyWatcher(
  url: string = envs.clientUrl,
  interval: number = 5000
) {
  const [latency, setLatency] = useState<number | null>(null)
  useEffect(() => {
    let isMounted = true

    const measureLatency = async () => {
      const startTime = performance.now()

      try {
        await fetch(url, { method: 'HEAD', cache: 'no-store' })
        const endTime = performance.now()

        if (isMounted) setLatency(endTime - startTime)
      } catch {
        if (isMounted) setLatency(null)
      }
    }

    const intervalId = setInterval(measureLatency, interval)
    measureLatency()

    return () => {
      isMounted = false
      clearInterval(intervalId)
    }
  }, [url, interval])

  return latency
}
